import { ref, isRef } from '@vue/composition-api'
import appearancesApi from '@/services/api/appearances'
import useScrollToError from '@/composables/useScrollToError'
import { FRAME_CONFIG } from './constants'
import { defaultForm, defaultPreviews, applyResponse } from './useAppearance'

export default function useAppearanceForm(frameArg, form, previews) {
  const frameRef = isRef(frameArg) ? frameArg : ref(frameArg)
  const submitting = ref(false)
  const resetting = ref(false)
  const errors = ref({})
  useScrollToError(errors)

  async function save(files) {
    const config = FRAME_CONFIG[frameRef.value]
    submitting.value = true
    errors.value = {}
    try {
      const formData = new FormData()
      formData.append('schema_color', form.schema_color)
      formData.append('sponsor_link', form.sponsor_link)

      if (config.hasLogoLinks) {
        for (let i = 1; i <= config.logoCount; i += 1) {
          formData.append(`sponsor_logo_${i}_link`, form[`sponsor_logo_${i}_link`])
        }
      }

      config.fileKeys.forEach((key) => {
        if (files[key]) formData.append(key, files[key])
      })

      const res = await appearancesApi.update(frameRef.value, formData)
      applyResponse(form, previews, res.data.data, config)
      return true
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      if (data != null && data.code === 'validation_error') {
        errors.value = data.errors
      }
      return false
    } finally {
      submitting.value = false
    }
  }

  async function reset() {
    const config = FRAME_CONFIG[frameRef.value]
    resetting.value = true
    try {
      await appearancesApi.reset(frameRef.value)
      Object.assign(form, defaultForm(config))
      Object.assign(previews, defaultPreviews(config))
    } finally {
      resetting.value = false
    }
  }

  return { submitting, resetting, errors, save, reset }
}



// WEBPACK FOOTER //
// ./src/composables/appearances/useAppearanceForm.js